import { API } from "../urls";

const getHeaders = () => ({
    "Content-Type": "application/json",
});

const fetchOpts = { credentials: "include" };

// ─── COMPANY_ADMIN ───────────────────────────────────────────

export const getAvailablePlans = async () => {
    const res = await fetch(API.subscription_plans, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Paketler yüklenemedi");
    return res.json();
};

export const getCurrentSubscription = async () => {
    const res = await fetch(API.subscription_current, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Abonelik durumu alınamadı");
    return res.json();
};

export const continueWithFreePlan = async () => {
    const res = await fetch(API.subscription_continue_with_free, { method: "POST", ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Ücretsiz pakete geçilemedi");
    return res.json();
};

export const acknowledgeFreeFallbackNotice = async () => {
    const res = await fetch(API.subscription_free_fallback_ack, { method: "POST", ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Bildirim kapatılamadı");
    return res.json();
};

export const getInvoiceInfo = async () => {
    const res = await fetch(API.subscription_invoice_info, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Fatura bilgileri alınamadı");
    return res.json();
};

export const calculatePrice = async (payload) => {
    const res = await fetch(API.subscription_calculate, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Fiyat hesaplanamadı");
    return res.json();
};

export const validateCoupon = async (payload) => {
    const res = await fetch(API.subscription_validate_coupon, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Kupon doğrulanamadı");
    return res.json();
};

/**
 * Paket ödemesinde sunulacak taksit seçenekleri.
 * İşaretli bir grup yoksa backend 404 döner; bu hata değil, "taksit kapalı" demektir.
 */
export const getSubscriptionInstallmentGroup = async () => {
    const res = await fetch(API.subscription_installment_group, { ...fetchOpts, headers: getHeaders() });
    return res.json();
};

export const purchaseSubscription = async (payload) => {
    const res = await fetch(API.subscription_purchase, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Satın alma başarısız");
    return res.json();
};

export const getSubscriptionHistory = async () => {
    const res = await fetch(API.subscription_history, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Geçmiş yüklenemedi");
    return res.json();
};

export const getRenewalInfo = async () => {
    const res = await fetch(API.subscription_renewal_info, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Yenileme bilgisi yüklenemedi");
    return res.json();
};

export const downloadInvoice = async (subscriptionId) => {
    const res = await fetch(API.subscription_invoice(subscriptionId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error("Fatura indirilemedi");
    return res.blob();
};

// ─── CANCEL ────────────────────────────────────────────────

export const cancelSubscription = async (reason) => {
    const res = await fetch(API.subscription_cancel, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ reason }),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Abonelik iptal edilemedi");
    return res.json();
};

// ─── DOWNGRADE ──────────────────────────────────────────────

export const scheduleDowngrade = async (targetPlanId, reason) => {
    const res = await fetch(API.subscription_downgrade, {
        ...fetchOpts,
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({ targetPlanId, reason }),
    });
    if (!res.ok) throw new Error((await res.json()).message || "İşlem başarısız");
    return res.json();
};

// ─── UPGRADE ─────────────────────────────────────────────────

export const getUpgradePreview = async (targetPlanId, couponCode) => {
    const res = await fetch(API.subscription_upgrade_preview, {
        ...fetchOpts,
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({ targetPlanId, couponCode }),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Önizleme alınamadı");
    return res.json();
};

export const upgradeSubscription = async (payload) => {
    const res = await fetch(API.subscription_upgrade, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Yükseltme başarısız");
    return res.json();
};

// 3DS ödeme başlat (HTML veya JSON dönebilir)
export const initiate3DSPayment = async (payload, isUpgrade = false) => {
    const endpoint = isUpgrade ? API.subscription_upgrade : API.subscription_purchase;
    const res = await fetch(endpoint, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    return res;
};

// ─── SUPER_ADMIN ─────────────────────────────────────────────

// Plans CRUD
export const adminGetPlans = async () => {
    const res = await fetch(API.admin_subscription_plans, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Paketler yüklenemedi");
    return res.json();
};

export const adminCreatePlan = async (payload) => {
    const res = await fetch(API.admin_subscription_plans, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Paket oluşturulamadı");
    return res.json();
};

export const adminUpdatePlan = async (id, payload) => {
    const res = await fetch(API.admin_subscription_plan(id), {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Paket güncellenemedi");
    return res.json();
};

export const adminDeletePlan = async (id) => {
    const res = await fetch(API.admin_subscription_plan(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Paket silinemedi");
    return res.json();
};

// Coupons CRUD
export const adminGetCoupons = async () => {
    const res = await fetch(API.admin_coupons, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Kuponlar yüklenemedi");
    return res.json();
};

export const adminCreateCoupon = async (payload) => {
    const res = await fetch(API.admin_coupons, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Kupon oluşturulamadı");
    return res.json();
};

export const adminUpdateCoupon = async (id, payload) => {
    const res = await fetch(API.admin_coupon(id), {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Kupon güncellenemedi");
    return res.json();
};

export const adminDeleteCoupon = async (id) => {
    const res = await fetch(API.admin_coupon(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Kupon silinemedi");
    return res.json();
};

// Coupon Detail
export const adminGetCoupon = async (id) => {
    const res = await fetch(API.admin_coupon(id), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Kupon bilgisi yüklenemedi");
    return res.json();
};

export const adminGetCouponUsages = async (id) => {
    const res = await fetch(API.admin_coupon_usages(id), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Kullanım geçmişi yüklenemedi");
    return res.json();
};

// Price Overrides CRUD
export const adminGetPriceOverrides = async () => {
    const res = await fetch(API.admin_price_overrides, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Fiyat müdahaleleri yüklenemedi");
    return res.json();
};

export const adminCreatePriceOverride = async (payload) => {
    const res = await fetch(API.admin_price_overrides, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Fiyat müdahalesi oluşturulamadı");
    return res.json();
};

export const adminUpdatePriceOverride = async (id, payload) => {
    const res = await fetch(API.admin_price_override(id), {
        method: "PUT",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Fiyat müdahalesi güncellenemedi");
    return res.json();
};

export const adminDeletePriceOverride = async (id) => {
    const res = await fetch(API.admin_price_override(id), {
        method: "DELETE",
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Fiyat müdahalesi silinemedi");
    return res.json();
};

// Admin Dashboard
export const getAdminDashboardStats = async () => {
    const res = await fetch(API.admin_subscription_dashboard_stats, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "İstatistikler alınamadı");
    return res.json();
};

export const getAdminAllSubscriptions = async ({ status, search, page = 0, size = 25, plan, domain, expiring, groupBy, sortBy, sortDir }) => {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (search) params.append("search", search);
    if (plan) params.append("plan", plan);
    if (domain) params.append("domain", domain);
    if (expiring) params.append("expiring", expiring);
    if (groupBy) params.append("groupBy", groupBy);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDir) params.append("sortDir", sortDir);
    params.append("page", page);
    params.append("size", size);
    const res = await fetch(`${API.admin_subscription_all}?${params}`, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Abonelikler alınamadı");
    return res.json();
};

// İade işaretleme (SUPER_ADMIN)
export const markRefund = async ({ subscriptionId, refundAmount, reason }) => {
    const res = await fetch(API.admin_subscription_refund, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify({ subscriptionId, refundAmount, reason }),
    });
    if (!res.ok) throw new Error((await res.json()).message || "İade işaretlenemedi");
    return res.json();
};

// Firma abonelik ayarları güncelleme (SUPER_ADMIN) - yenileme fiyatı + hak limitleri
export const adminUpdateCompanySubscriptionSettings = async (payload) => {
    const res = await fetch(API.admin_subscription_company_settings, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error((await res.json()).message || "Abonelik ayarları güncellenemedi");
    return res.json();
};

// Firma abonelik geçmişi (SUPER_ADMIN - detay sayfası)
export const getCompanySubscriptionHistory = async (companyId) => {
    const res = await fetch(API.admin_subscription_company_history(companyId), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Abonelik geçmişi alınamadı");
    return res.json();
};

// Manuel paket tanımlama (SUPER_ADMIN)
// Yalnız üst pakete geçişte veri döner; diğer durumlarda null (bilgi amaçlı, hata sayılmaz).
export const adminGetUpgradePreview = async (companyId, targetPlanId) => {
    const res = await fetch(API.admin_subscription_upgrade_preview(companyId, targetPlanId), {
        ...fetchOpts,
        headers: getHeaders(),
    });
    if (!res.ok) return null;
    return (await res.json()).data || null;
};

export const adminAssignSubscription = async (payload) => {
    const res = await fetch(API.admin_subscription_assign, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok || data.statusCode >= 400) {
        throw new Error(data.message || "Abonelik tanımlanamadı");
    }
    return data;
};

// ─── PAKET ÖZELLİKLERİ / GÖRÜNÜRLÜK (V93) ────────────────────

/** Admin paket formundaki özellik kataloğu. Liste backend'de PlanFeature enum'undan üretilir. */
export const adminGetPlanFeatures = async () => {
    const res = await fetch(API.admin_plan_features, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Özellik kataloğu yüklenemedi");
    return res.json();
};

/**
 * Paket formundaki entegrasyon kataloğu (sanal POS + muhasebe).
 * Liste backend'de PlanIntegration enum'undan üretilir; yeni bir entegrasyon
 * eklendiğinde form kendiliğinden güncellenir, burada sabit liste tutulmaz.
 */
/** Firmanın paketinde açık olan entegrasyonlar. Kart kilitlemede kullanılır. */
export const getMyPlanIntegrations = async () => {
    const res = await fetch(API.my_plan_integrations, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Entegrasyon listesi yüklenemedi");
    return res.json();
};

/**
 * Firmanın gerçekten BAĞLANTI kurduğu entegrasyonlar. Paket kapsamı ayrı bir şeydir:
 * paket İşyerimPOS'a izin verse de bağlantı kurulmamış olabilir.
 */
export const getMyConnectedIntegrations = async () => {
    const res = await fetch(API.my_connected_integrations, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Bağlantı durumu yüklenemedi");
    return res.json();
};

/** Entegrasyon kataloğu — müşteri tarafı (Aboneliğim ekranı). Salt-okunur. */
export const getPlanIntegrationCatalog = async () => {
    const res = await fetch(API.plan_integration_catalog, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Entegrasyon kataloğu yüklenemedi");
    return res.json();
};

export const adminGetPlanIntegrations = async () => {
    const res = await fetch(API.admin_plan_integrations, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Entegrasyon kataloğu yüklenemedi");
    return res.json();
};

/** Firmaya hangi paketlerin sunulduğu ayarı. Kayıt yoksa varsayılan döner. */
export const adminGetCompanyPlanVisibility = async (companyId) => {
    const res = await fetch(API.admin_company_plan_visibility(companyId), { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Paket görünürlüğü alınamadı");
    return res.json();
};

/** Firmaya hangi paketlerin sunulacağını kaydeder. */
export const adminSaveCompanyPlanVisibility = async (payload) => {
    const res = await fetch(API.admin_company_plan_visibility_save, {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
        body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!res.ok || data.statusCode >= 400) {
        throw new Error(data.message || "Paket görünürlüğü kaydedilemedi");
    }
    return data;
};

/**
 * Giriş yapan firmanın paketindeki açık özellikler.
 * Menü/buton gizlemek için kullanılır — güvenlik sınırı DEĞİLDİR,
 * asıl reddetme backend'deki PlanFeatureInterceptor tarafından yapılır.
 */
export const getMyPlanFeatures = async () => {
    const res = await fetch(API.my_plan_features, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Paket özellikleri alınamadı");
    return res.json();
};

/**
 * Firmanın özellik deneme durumu ({trialDays, trials}). Paket dışı bir menüye
 * tıklandığında açılan pencerede, denemenin daha önce kullanılıp kullanılmadığını
 * anlamak için okunur.
 */
export const getFeatureTrials = async () => {
    const res = await fetch(API.feature_trials, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Deneme bilgisi alınamadı");
    return res.json();
};

/**
 * Bir özellik için ücretsiz denemeyi başlatır. Hak daha önce kullanılmışsa backend
 * 409 döner; mesajı olduğu gibi kullanıcıya göstermek için hata metni korunur.
 */
export const startFeatureTrial = async (featureCode) => {
    const res = await fetch(API.feature_trial_start(featureCode), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.statusCode >= 400) {
        throw new Error(data.message || "Deneme başlatılamadı");
    }
    return data;
};

/** Paket tahsilat limitinin bu dönemdeki kullanımı. */
export const getMyCollectionUsage = async () => {
    const res = await fetch(API.my_collection_usage, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Tahsilat limiti bilgisi alınamadı");
    return res.json();
};

/**
 * Özellik kataloğu (kod → etiket). Paket kartlarında özellik kodlarını okunur
 * metne çevirmek için kullanılır; firma kullanıcıları da erişebilir.
 */
export const getPlanFeatureCatalog = async () => {
    const res = await fetch(API.plan_feature_catalog, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Özellik kataloğu alınamadı");
    return res.json();
};

/** Firmanın paket deneme durumu: pencere, kalan gün, denenen/denenmiş paketler. */
export const getPlanTrialStatus = async () => {
    const res = await fetch(API.plan_trial_status, { ...fetchOpts, headers: getHeaders() });
    if (!res.ok) throw new Error((await res.json()).message || "Deneme durumu alınamadı");
    return res.json();
};

/** Bir paketi 14 günlük pencerede denemeye başlatır. */
export const startPlanTrial = async (planId) => {
    const res = await fetch(API.plan_trial_start(planId), {
        method: "POST",
        ...fetchOpts,
        headers: getHeaders(),
    });
    const body = await res.json();
    if (!res.ok) throw new Error(body.message || "Deneme başlatılamadı");
    return body;
};
